import { DEFAULT_POSITION, DEFAULT_ZOOM } from "./defaults";

const getSavedPosition = () => {
    const pos = localStorage.getItem("mapPos");
    if (!pos) {
        return DEFAULT_POSITION;
    }

    try {
        const parsedPos = JSON.parse(pos);
        console.log(`parsed ${parsedPos}`);
        if (
            Array.isArray(parsedPos) &&
            parsedPos.length === 2 &&
            typeof parsedPos[0] === "number" &&
            typeof parsedPos[1] === "number" &&
            parsedPos[0] >= -180 &&
            parsedPos[0] <= 180 &&
            parsedPos[1] >= -90 &&
            parsedPos[1] <= 90
        ) {
            return parsedPos;
        }
    } catch (e) {
        console.error(`Error occured while getting saved position: ${e}`);
    }

    return DEFAULT_POSITION;
};

const savePosition = (position) => {
    console.log(`saving ${position}`);
    if (
        Array.isArray(position) &&
        position.length === 2 &&
        typeof position[0] === "number" &&
        typeof position[1] === "number" &&
        position[0] >= -180 &&
        position[0] <= 180 &&
        position[1] >= -90 &&
        position[1] <= 90
    ) {
        localStorage.setItem("mapPos", JSON.stringify(position));
    }
};

const getSavedZoom = () => {
    const zoom = localStorage.getItem("mapZoom");
    if (!zoom) {
        return DEFAULT_ZOOM;
    }

    try {
        const parsedZoom = JSON.parse(zoom);
        if (
            typeof parsedZoom === "number" &&
            parsedZoom <= 20 &&
            parsedZoom >= DEFAULT_ZOOM
        ) {
            return parsedZoom;
        }
    } catch (e) {
        console.error(`Error occured while getting saved zoom: ${e}`);
    }

    return DEFAULT_ZOOM;
};

const saveZoom = (zoom) => {
    if (typeof zoom === "number" && zoom <= 20 && zoom >= DEFAULT_ZOOM) {
        localStorage.setItem("mapZoom", JSON.stringify(zoom));
    }
};

const getMapStyle = () => {
    const style = localStorage.getItem("mapStyle");
    if (!style) {
        return "OSM";
    }

    try {
        const parsedStyle = JSON.parse(style);
        const styleName = parsedStyle.toUpperCase();
        if (styleName === "OSM" || styleName === "SAT") {
            return styleName;
        }
    } catch (e) {
        console.error(`Error occured while getting saved map style: ${e}`);
    }

    return "OSM";
};

const saveMapStyle = (style) => {
    console.log(style);
    if (style === "OSM" || style === "SAT") {
        const name = style.toUpperCase();
        localStorage.setItem("mapStyle", JSON.stringify(name));
    }
};

export {
    getSavedPosition,
    savePosition,
    getSavedZoom,
    saveZoom,
    getMapStyle,
    saveMapStyle,
};
